module.exports = {"141026100":"府城镇","141026101":"和川镇","141026102":"唐城镇","141026103":"冀氏镇","141026200":"马必乡","141026201":"杜村乡","141026202":"良马乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141026.json
// module id = 367
// module chunks = 0